import type { ReactNode } from "react";
import { AIOrbAvatar } from "../ui/AIOrbAvatar";

/** Assistant row: the AI orb pinned bottom-left of whatever it renders (v3). */
export function AIAvatarRow({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-end justify-start gap-3">
      <div className="mb-0.5 flex shrink-0 items-center justify-center">
        <AIOrbAvatar size={34} staticCircle />
      </div>
      {children}
    </div>
  );
}
